import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"

export const upsertScimGroupMapping = api(async function upsertScimGroupMapping({ id, input, clientId } = {}) {
    return await mutate(
        gql`
            mutation upsertScimGroupMapping($id: String, $input: ScimGroupMappingInput!, $clientId: String) {
                upsertScimGroupMapping(id: $id, input: $input, clientId: $clientId) {
                    _id
                    externalId
                    displayName
                    license
                    roles
                    priority
                }
            }
        `,
        { id, input, clientId },
        { returns: "upsertScimGroupMapping" }
    )
})

export const deleteScimGroupMapping = api(async function deleteScimGroupMapping({ id, clientId } = {}) {
    return await mutate(
        gql`
            mutation deleteScimGroupMapping($id: String!, $clientId: String) {
                deleteScimGroupMapping(id: $id, clientId: $clientId)
            }
        `,
        { id, clientId },
        { returns: "deleteScimGroupMapping" }
    )
})
